module.exports = {"id":"216706","name":"Franco Mussis","rating":"76","photo":"./data/images/photos/1/216706.png","club":{"name":"San Lorenzo","logo":"./data/images/clubs/SanLorenzo.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FrancoMussis0.json
// module id = 1483
// module chunks = 0